/** Default Lyve copilot (Xavi) — IDs match TemporaryChatContext. */
export const DEFAULT_COPILOT = {
  label: 'Xavi',
  value: '98aa47bc-6fa2-4fa8-8cff-6fd8c1cb3720',
  icon: 'https://feedalabs-agent-icon.s3.eu-north-1.amazonaws.com/xavi_d3ce97c93fa24083ba18ed9107fc8f35.jpg',
  mode: 'agent',
};

export const DEFAULT_COPILOT_ID = DEFAULT_COPILOT.value;
export const DEFAULT_COPILOT_NAME = DEFAULT_COPILOT.label;
export const DEFAULT_COPILOT_ICON = DEFAULT_COPILOT.icon;

export function isDefaultCopilot(agent) {
  if (!agent) return false;
  const id = agent.value ?? agent.id ?? agent.agent_id;
  const name = (agent.label || agent.agent_name || '').toLowerCase().trim();
  return String(id) === DEFAULT_COPILOT_ID || name === 'xavi' || name === 'ferdy';
}

export function findDefaultCopilot(agents) {
  if (!agents?.length) return null;
  return agents.find(a => isDefaultCopilot(a)) || null;
}

/** Map an API agent to a select/context option; brand the default as Xavi. */
export function toDefaultAwareAgentOption(agent) {
  if (!agent) return null;
  const value = agent.id ?? agent.agent_id ?? agent.value;
  if (isDefaultCopilot(agent) || String(value) === DEFAULT_COPILOT_ID) {
    return {
      label: DEFAULT_COPILOT_NAME,
      value: DEFAULT_COPILOT_ID,
      icon: DEFAULT_COPILOT_ICON,
      mode: 'agent',
    };
  }
  return {
    label: agent.agent_name || agent.label,
    value,
    icon: agent.icon ?? null,
    mode: agent.mode || 'agent',
  };
}
